const SearchExecutionStatus = {
	SEARCHING: 'SEARCHING',
	COMPLETED: 'COMPLETED',
	ERROR: 'ERROR',
};

module.exports = SearchExecutionStatus;
